<template>
  <div class="download-log-list">
    <el-table :data="downloadLogList" border stripe align="center" :header-cell-style="headerStyle" header-align="center" :cell-style="rowStyle" style="width: 100%" empty-text>
      <el-table-column prop="name" label="资源名称"></el-table-column>
      <el-table-column prop="type" label="资源类型">
        <template slot-scope="scope">
          <template v-if="scope.row.type  == 'FIVE_HUNDRED'">500平方米展厅资料</template>
          <template v-else-if="scope.row.type  == 'THOUSAND'">1000平方米展厅资料</template>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="下载时间"></el-table-column>
    </el-table>
    <div class="page-btn">
      <el-pagination background layout="total, prev, pager, next, sizes" @current-change="pageChangeCurrent" @size-change="pageChangeSize" :page-sizes="[10, 20, 50, 80, 100, 150, 200]" :page-size="pageSize" :total="pageTotal"></el-pagination>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { getDownloadList } from '@/api/download'

export default {
  name: 'DownloadLogView',
  data() {
    return {
      downloadLogList: null,
      pageTotal: 0,
      pageSize: 20,
      pageNum: 1
    }
  },
  mounted() {
    if(!window.localStorage.getItem('isLogin')){
      this.$router.push('/')
    }
    this.getDownloadLogList(this.pageSize, this.pageNum)
  },
  methods: {
    rowStyle(){
      return "text-align: center"
    },
    headerStyle() {
      return "text-align: center; color: #c01509; font-size: 18px;"
    },
    // 指定页面数量
    pageChangeSize(val) {
      this.pageSize = val
      this.getDownloadLogList(this.pageSize, this.pageNum)
    },
    // 分页
    pageChangeCurrent(val) {
      this.pageNum = val
      this.getDownloadLogList(this.pageSize, this.pageNum)
    },
    // 获取下载记录列表
    getDownloadLogList(pageSize, pageNum) {
      getDownloadList({
        pageSize,
        pageNum
      }).then(res => {
        if(res.data.code == 200){
          this.pageTotal = res.data.total
          this.downloadLogList = res.data.rows
        }else{
          this.$router.push('/')
        }
      })
    }
  }
}
</script>

<style scoped>
.wrapper {
  overflow: hidden;
}
.download-log-list {
  padding: 100px;
  width: 80%;
}
.page-btn {
  background-color: #fff;
  padding: 30px 0;
  text-align: center;
}
</style>
